import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { ellipsis } from 'polished';
import posthog from 'posthog-js';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20, GoCircleIcon } from '@styled/icon';
import moReport, {
  initIndustryReport, hoverCard, leaveCard, onMore,
} from './store';
import Slick from '../../component/slick';
import Empty from '@comp/empty';

interface IProps {}
interface IState {}

const FButton = styled(Button)(() => ({
  padding: '2px 6px',
  fontSize: '14px',
  lineHeight: 1.2,

  '&:hover': { backgroundColor: Color.primaryColor(0.04) },
  '.MuiButton-endIcon': { marginLeft: '4px' },
}));

const IndustryReport = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { reportList, allReportList } = moReport;

  // 点击行业研报
  const onReport = (uri: string) => {
    posthog.capture('行业研究-行业研报', {});
    window.open(uri);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="research2" className="industry-report_10">
      <p className="line-301">
        <strong className="sub-11">行业研报</strong>
        {!isEmpty(allReportList) ? (
          <FButton onClick={onMore}
            endIcon={<GoCircleIcon color={Color.primary} width={16} height={16} />}>更多
          </FButton>
        ) : null}
      </p>
      {!isEmpty(allReportList) ? (
        <section className="slick-section">
          {allReportList && allReportList.slice(0, 3).map((item: any) => (
            <section key={item.uuid} aria-hidden="true"
              onMouseEnter={() => hoverCard(item.uuid)}
              onMouseLeave={() => leaveCard(item.uuid)}
              onClick={() => onReport(item.file_url)}
              className={[
                'card-030', item.active ? 'active' : '',
              ].join(' ')}>
              <section className="section-361">
                <p className={['card-line-29'].join(' ')}
                  style={{ backgroundImage: `url(${item.img_url})` }}>
                  <img src={item.img_url} alt="" className="img-007"
                    style={{ display: 'none' }} />
                </p>
                <p className="card-line-30">
                  <span style={{ ...ellipsis('100%', 2) }}>
                    {item.description}
                  </span>
                </p>
              </section>
              {item.active ? <img src="https://file.smartsalary.cn/web-img%402.0/market/image/shadow-bg-blue.png" alt="" className="blur_006" /> : null}
            </section>
          ))}
        </section>
      ) : <Empty padding="50px 0" />}
    </section>
  );
};

export default observer(IndustryReport);
